module.exports = __webpack_public_path__ + "images/icons_v2/document-outlined-1232936a.svg";